import React from "react";
//#region types
import { LinearStateFlowProps } from "models/propTypes/stateFlowPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid, Stepper, Step, Grow, StepLabel } from "@mui/material";
import LinearStepConnector from "./linearStepConnector";
import ProfileImage from "../profile/profileImage";
import Icon from "../icon";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const LinearStateFlow: React.FC<LinearStateFlowProps> = (props) => {
  const { steps, activeStep, loading, isActiveAtIntermediateState } = props;

  return (
    <Stepper
      activeStep={activeStep}
      className={cssExports.stateFlowContainer}
      connector={
        <LinearStepConnector isActiveAtIntermediateState={isActiveAtIntermediateState} activeStep={activeStep} />
      }
      alternativeLabel
    >
      {steps.map((step, index) => {
        const isActiveStep = index <= activeStep;
        return (
          <Grow
            key={`${step.stateText}-${step.date}-${step.updatedById}-${index}`}
            in={true}
            style={{ transformOrigin: "0 0 0" }}
            timeout={loading ? undefined : index === 0 ? 0 : 300 + +index * 700}
          >
            <Step
              className={clsx(
                index === activeStep ? cssExports.stepActive : index > activeStep ? cssExports.stepDisabled : "",
                cssExports.statusFlowStep,
                cssExports.linerStatusFlowStep
              )}
            >
              <StepLabel
                classes={{
                  iconContainer: cssExports.stepIconContainer,
                  label: cssExports.stepLabel,
                }}
              >
                <Grid container direction="column" alignItems="center">
                  <Grid item>
                    <label className={cssExports.statusLabel}>{step.stateText}</label>
                  </Grid>
                  <Grid item className={cssExports.stateFlowIcon}>
                    {isActiveStep ? (
                      <ProfileImage
                        id={step.updatedById}
                        name={step.updatedByName ? step.updatedByName : ""}
                        className={cssExports.avatar}
                        showDefaultAvatar={!step.date}
                      ></ProfileImage>
                    ) : (
                      <Icon icon={IconDefinitionConstants.WBulletFuture} />
                    )}
                  </Grid>
                  <Grid item className={cssExports.stateFlowText}>
                    <span>
                      {step.date
                        ? LocalizationHelperInstance.getFormattedDate(step.date, {
                            day: "numeric",
                            month: "short",
                          })
                        : ""}
                    </span>
                  </Grid>
                </Grid>
              </StepLabel>
            </Step>
          </Grow>
        );
      })}
    </Stepper>
  );
};

export default LinearStateFlow;
